export default __webpack_public_path__ + "static/media/1639.f2c3fb45.png";